import useAuthAxios from "../../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";
import { API } from "../../constant/api";

const GetTickers = () => {
  const axiosInstance = useAuthAxios();

  const getTicker = async () => {
    try {
      const response = await axiosInstance.get(API.getTickers);
      const tickers = response?.data?.data?.tickers ?? {};
      return tickers;
    } catch (error) {
      console.error("Error fetching tickers:", error);
      return error as any;
    }
  };

  const {
    data: tickers,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["get-ticker"],
    queryFn: getTicker,
    retry: 1,
  });

  return { data: tickers, isLoading, refetch };
};

export default GetTickers;
